import * as XLSX from 'xlsx';
import { format } from 'date-fns';

export interface ExportExcelOptions {
  /** Sheet name (default: 'Sheet1') */
  sheetName?: string;
  /** File name without extension (default: 'export-YYYY-MM-dd') */
  fileName?: string;
}

/**
 * Build an Excel file from an array of row objects and trigger download.
 * Keys of the first row object become column headers.
 *
 * @param rows - Array of plain objects (e.g. [{ ID: 1, Name: 'A' }, ...])
 * @param options - Optional sheet name and file name
 */
export function exportToExcel(
  rows: Record<string, string | number | boolean | undefined | null>[],
  options: ExportExcelOptions = {}
): void {
  const { sheetName = 'Sheet1', fileName = `export-${format(new Date(), 'yyyy-MM-dd')}` } = options;
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const fullFileName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  XLSX.writeFile(wb, fullFileName);
}
